import React from 'react';
import { validated } from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { isEmail, isRequired } from 'utils/validations';

import Button from 'components/Button';
import Form from 'components/Form';
import FormValidationMessage from 'components/FormValidationMessage';
import FormRow from 'components/FormRow';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox';

class LoginForm extends React.Component {
    static propTypes = {
        error: PropTypes.object.isRequired,
        isFetching: PropTypes.bool.isRequired,
        credentials: PropTypes.object.isRequired,
        onValid: PropTypes.func.isRequired,
        onInvalid: PropTypes.func.isRequired,
        setCredentials: PropTypes.func.isRequired
    };

    _handleChange(event) {
        let name = event.target.name;
        let newCredentialsObj = update(this.props.credentials, {});
        newCredentialsObj[name] = event.target.value;
        this.props.setCredentials(newCredentialsObj);
    }

    render() {
        let { credentials, isFetching, onValid, onInvalid, $field, $validation } = this.props;
        return (
            <Form>
                <FormRow>
                    <Textbox
                        id="txtEmail"
                        label="Email"
                        name="email"
                        placeholder="Your email address"
                        type="text"
                        validation={$validation.email}
                        value={credentials.email}
                        {...$field('email', (event) => this._handleChange(event))}
                    />
                </FormRow>
                <FormRow>
                    <Textbox
                        id="txtPassword"
                        label="Password"
                        name="password"
                        placeholder="Your password"
                        type="password"
                        validation={$validation.password}
                        value={credentials.password}
                        {...$field('password', (event) => this._handleChange(event))}
                    />
                </FormRow>
                <FormRow className="error-message">
                    {Object.keys(this.props.error).length > 0 ? (
                        <FormValidationMessage>
                            {this.props.error.friendlyMessage || this.props.error.message}
                        </FormValidationMessage>
                    ) : null}
                </FormRow>
                <FormRow className="button-wrapper">
                    <Button type="submit"
                            disabled={isFetching}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid);
                            }}>
                        Log In
                        {isFetching === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        )
    }
}

function loginFormValidationConfig(props) {
    const { email, password } = props.credentials;

    return {
        fields: ['email', 'password'],
        validations: {
            email: [
                [isRequired, email],
                [isEmail, email]
            ],
            password: [
                [isRequired, password]
            ]
        }
    }
}

export default LoginForm = validated(loginFormValidationConfig)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/LoginPage/LoginForm.js